<template>
  <div class="loader" :style="{'z-index': zIndex}">
    <div class="loader__spinner" v-if="spinner">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>

    <div class="loader__bar" v-if="typeof progress != 'undefined'">
      <div class="loader__bar--progress" :style="{'width': `${progress}%`}"></div>
    </div>
    <p class="loader__text" v-if="text">{{text}}</p>
  </div>
</template>

<script>
export default {
  name: "loader",
  props: {
    progress: Number,
    spinner: Boolean,
    text: String,
    "zIndex": { type: Number, default: 100 }
  }
};
</script>

<style lang="scss" scoped>
.loader {
  position: fixed;
  z-index: 100;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  background: #efefef;
}

.loader__bar {
  margin: 1rem;
  width: 40%;
  min-width: 250px;
  height: 8px;
  background: #666;
}

.loader__bar--progress {
  height: 8px;
  background: $primaryColor;
  transition: 200ms;
}

.loader__spinner {
  display: inline-block;
  position: relative;
  width: 64px;
  height: 64px;
}
.loader__spinner div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 51px;
  height: 51px;
  margin: 6px;
  border: 6px solid $primaryColor;
  border-radius: 50%;
  animation: loader__spinner 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: $primaryColor transparent transparent transparent;
}
.loader__spinner div:nth-child(1) {
  animation-delay: -0.45s;
}
.loader__spinner div:nth-child(2) {
  animation-delay: -0.3s;
}
.loader__spinner div:nth-child(3) {
  animation-delay: -0.15s;
}
@keyframes loader__spinner {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>

